export default {"src":"/_next/static/media/people.fee6a86b.svg","height":20,"width":19};